import { render, staticRenderFns } from "./PriceDeviations.vue?vue&type=template&id=2cc24e4e&"
import script from "./PriceDeviations.vue?vue&type=script&lang=js&"
export * from "./PriceDeviations.vue?vue&type=script&lang=js&"
import style0 from "./PriceDeviations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports